//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dedicatedItem from '../../../../../../../local/vue.js/v-dedicated-solution-item/v-dedicated-solution-item.vue';
import dedicatedFilter from '../../../../../../../local/vue.js/v-dedicated-solutions-filter/v-dedicated-solutions-filter.vue';
import {jFunc} from "../../../../../../js/jfunctions.min";


export default {
  name: "dedicated-solutions",
  components: {
    'v-dedicated-item' : dedicatedItem,
    'v-dedicated-filter' : dedicatedFilter
  },
  data() {
    return {
      ITEMS : {},
      COMPONENTS:{},
      filteredIds : [], // model of filter component
    }
  },
  methods: {
    run(fn) {
      fn();
    },
  },
  computed : {
    filteredItems() {
      let self = this;
      let result = [];

      for(let itemIndex in self.ITEMS) {
          let currentItem = self.ITEMS[itemIndex];

          if(self.filteredIds.indexOf(currentItem.ID) > -1) {
            result.push(currentItem);
          }
      }

      return jFunc.sortArrayOfObjectsByKeyValue(result, 'SORT');
    },
    filterItems() {
      let self = this;
      let result = [];

      if(Object.keys(self.filteredIds).length) { // need for trigger updating
        result = self.$refs.filter.$data.filterSelectedItems;
      }

      return result;
    },
  },
  mounted() {
    $('.dedicated-solutions-filter-open').on('click', function () {
      $('.dedicated-solutions-filter').addClass('active');
      $('.overlay').addClass('active');
    });
    $('.overlay').on('click', function () {
      if ($('.dedicated-solutions-filter').hasClass('active')) {
        $('.dedicated-solutions-filter').removeClass('active');
        $('.overlay').removeClass('active');
      }
    });
    // $('.filtered-item img').on('click', function () {
    //   var self = $(this);
    //   var item = self.closest('.filtered-item');
    //   if (!item.hasClass('removed-all')) {
    //     item.addClass('hide');
    //     setTimeout(function () {
    //       item.remove();
    //     }, 300);
    //   } else {
    //     $('.filtered-item').each(function (i, el) {
    //       $(el).addClass('hide');
    //       setTimeout(function () {
    //         $(el).remove();
    //       }, 300)
    //
    //     });
    //   }
    //
    // });
  }
}



// WEBPACK FOOTER //
// ./depohost.ru/local/templates/depohost/components/bitrix/catalog.section/dedicated-solutions/template.vue